function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 16,
  fill: "#6DC4F2",
  transform: "scale(1 -1) rotate(89.888 211.04 194.627)"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 86.575,
  cy: 75.839,
  r: 8.5,
  fill: "#6187DE",
  transform: "rotate(-89.888 86.575 75.84)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6DC4F2",
  strokeWidth: 5,
  d: "M13.103 31.849c5.892.011 10.49 4.589 10.48 10.02-.01 5.432-4.627 9.991-10.52 9.98-5.892-.012-10.49-4.59-10.48-10.02.01-5.432 4.627-9.992 10.52-9.98z"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.678,
  cy: 54.77,
  r: 11,
  stroke: "#FFD13C",
  strokeWidth: 5,
  transform: "rotate(-89.888 137.678 54.77)"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 300.654,
  cy: 67.09,
  r: 11,
  stroke: "#33D5BA",
  strokeWidth: 5,
  transform: "rotate(-89.888 300.654 67.09)"
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 219.231,
  cy: 27.43,
  r: 9,
  fill: "#FF4D3D",
  transform: "rotate(-89.888 219.231 27.43)"
});
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422,
    height: 85,
    fill: "none",
    viewBox: "0 0 422 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5be3c8ca9deaf9da95d056379b6f81e7.svg";
export { ForwardRef as ReactComponent };